<h2>{{(data.type === 'edit' ? 'editLicense.title' : data.type === 'add' ? 'editLicense.addTitle' : 'editLicense.deleteTitle') | translate}}</h2>
<p>{{(data.type === 'edit' ? 'editLicense.description' : data.type === 'add' ? 'editLicense.addDescription' : 'editLicense.deleteDescription') | translate}}</p>

<form [formGroup]="licenseForm" *ngIf="data.type === 'edit' || data.type === 'add'">
    <div class="form-column">
        <h4><b>{{ 'editLicense.nameLabel' | translate }}</b></h4>
        <mat-form-field appearance="fill" [ngClass]="{'invalid': licenseForm.get('name_customer')?.invalid && licenseForm.get('name_customer')?.touched}">
            <input matInput formControlName="name_customer" [placeholder]="'editLicense.namePlaceholder' | translate">
        </mat-form-field>
    </div>
    <div class="form-column">
        <h4><b>{{ 'editLicense.emailLabel' | translate }}</b></h4>
        <mat-form-field appearance="fill" [ngClass]="{'invalid': licenseForm.get('assigned_to_mail')?.invalid && licenseForm.get('assigned_to_mail')?.touched}">
            <input matInput formControlName="assigned_to_mail" [placeholder]="'editLicense.emailPlaceholder' | translate">
        </mat-form-field>
    </div>
</form>

<div class="form-column" *ngIf="data.type === 'delete'">
    <h4><b>{{ 'editLicense.nameLabel' | translate }}</b></h4>
    <p>{{licenseForm.get('name_customer')?.value}}</p>
    <h4 style = "margin-top: 20px;"><b>{{ 'editLicense.emailLabel' | translate }}</b></h4>
    <p>{{licenseForm.get('assigned_to_mail')?.value}}</p>
</div>

<div class="form-column" *ngIf="error_message">
    <p style = "color: #ff0000 !important;">{{ 'editLicense.error' | translate: {message: error_message} }}</p>
</div>

<div class="actions" style = "margin-top: 60px;">
    <div class = "actions-right first-actions">
        <button mat-raised-button color="primary" class = "linkedin-button" (click)="data.type === 'edit' ? saveEditLicense() : data.type === 'add' ? addLicense() : deleteLicense()">
        <span  *ngIf="!loading">{{(data.type === 'edit' ? 'editLicense.buttonText' : data.type === 'add' ? 'editLicense.addButtonText' : 'editLicense.deleteButtonText') | translate}}</span>
        <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'editLicense.loading' | translate"></div>
        </button>
    </div>
</div>

<button mat-icon-button class="close-modal-btn" style="position: absolute; top: 10px; right: 10px;" (click)="close()" [attr.aria-label]="'editLicense.close' | translate">
  <div class="close-modal-btn-container">
    <p class="close-modal-btn-text">&times;</p>
  </div>
</button>
